export const typesenseSearchActions = [
  {
    name: 'reindexDataForTypesenseCollection',
    label: 'Re Index Data for Typesense Collection',
    args: [
      {
        name: 'typesenseCollection',
        label: 'Select Typesense Collection',
        type: 'dropdown',
        optionsType: 'typesenseSearchCollectionApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'deleteTypesenseCollection',
    label: 'Delete Typesense Collection',
    args: [
      {
        name: 'typesenseCollection',
        label: 'Select Typesense Collection',
        type: 'dropdown',
        optionsType: 'typesenseSearchCollectionApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
